import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetPastAndActiveEventsData, IGetPastAndActiveEventsVars } from '../types';

export const GET_PAST_ACTIVE_EVENTS: TypedDocumentNode<IGetPastAndActiveEventsData, IGetPastAndActiveEventsVars> = gql`
  query getPastAndActiveEvents($input: PastAndActiveEventsInput!) {
    pastAndActiveEvents(input: $input) {
      eventTitle
      asmtEventId
      eventStartDt
      rooms {
        title
        capacity
      }
    }
  }
`;
